import ResponsiveImage, {Props} from 'epic-fortnite-react/components/common/ResponsiveImage';
import styled from 'styled-components';

import {Device} from '../../../../constants';

const CrewImage = styled(ResponsiveImage)<Props>`
  display: block;
  height: 100%;
  position: absolute;
  left: 0;

  & img {
    height: 100%;
    width: auto;
  }
  @media screen and ${Device.laptop} {
    height: unset;
    position: unset;

    & img {
      height: unset;
      width: 100%;
    }
  }

  @media screen and ${Device.mobileL} {
    height: unset;
    position: unset;
  }
`;

export default CrewImage;
